export const PIPELINE_STATUS = {
    pending: 'PN',
    started: 'ST',
    progress: 'PR',
    paused: 'PS',
    success: 'SC',
    failure: 'FL',
    retry: 'RT',
    revoked: 'RV',
}
